<template>
  <div v-if="closedAt !== updatedAt" class="bg-orange shadow-md">
    <div class="container flex text-white items-start justify-center">
      <div
        class="font-bold leading-1.25 text-12 lg:text-16 px-20 py-10 lg:leading-1.2 lg:py-12"
      >
        <slot></slot>
      </div>
      <button
        class="text-white mt-6 lg:mt-10 text-16 focus:outline-none mr-14 lg:mr-0"
        @click="closedAt = updatedAt"
      >
        <i class="fal fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
const KEY = "updatedAt";

export default {
  props: {
    updatedAt: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      closedAt: window.localStorage.getItem(KEY),
    };
  },

  watch: {
    closedAt() {
      window.localStorage.setItem(KEY, this.updatedAt);
    },
  },
};
</script>
